export default __webpack_public_path__ + "static/media/warning--junction-with-a-side-road-perpendicular-right--g3.928aa62d.png";